// extracted by mini-css-extract-plugin
module.exports = {"root":"App_root__2h8CC","container":"App_container__1MQN3","leftContainer":"App_leftContainer__3WVeI","rightContainer":"App_rightContainer__2HVuk"};